import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
	ApiService,
	AppSettingsService,
	FormattedDatePipe,
	StatefulService,
	ShopperService,
} from '@woolworthsnz/styleguide';
import { CanCancelOrderResponse, PastOrderUpdateResponse } from '@woolworthsnz/trader-api';
import { Observable, take } from 'rxjs';

export interface CancelOrderState {
	orderId?: number;
	isOrderCancellableResponse?: CanCancelOrderResponse;
	deliveryMethod?: string;
	deliveryWindow?: string;
}

@Injectable({
	providedIn: 'root',
})
export class CancelOrderService extends StatefulService<CancelOrderState> {
	constructor(
		private apiService: ApiService,
		private appSettingsService: AppSettingsService,
		private dateFormatter: FormattedDatePipe,
		private shopperService: ShopperService,
		private router: Router
	) {
		super({});
	}

	getIsOrderCancelleable(orderId: number): Observable<CanCancelOrderResponse> {
		return this.apiService.get(`${this.appSettingsService.getEndpoint('isOrderCancelleable')}/${orderId}`, {
			params: { cacheBust: Date.now() },
		});
	}

	cancelOrder(orderId: number): Observable<PastOrderUpdateResponse> {
		return this.apiService.delete(`${this.appSettingsService.getEndpoint('cancelOrder')}/${orderId}`);
	}

	setOrderDetails(deliveryMethod: string, deliveryDate: string | Date, deliveryTime: string): void {
		this.setState({
			deliveryMethod: deliveryMethod,
			deliveryWindow: `${this.dateFormatter.transform(deliveryDate)} ${deliveryTime}`,
		});
	}

	getAndSaveOrderCancellableState(orderId: number): void {
		this.getIsOrderCancelleable(orderId)
			.pipe(take(1))
			.subscribe(
				(r) => {
					this.setState({
						isOrderCancellableResponse: r,
						orderId: orderId,
					});
				},
				() => {
					this.setState({
						isOrderCancellableResponse: { isSuccessful: false },
						orderId: orderId,
					});
				}
			);
	}

	setOrderId(orderId: number): void {
		this.setState({
			orderId: orderId,
		});
	}

	openCancelOrderModal(orderId: number, calledFrom?: string): void {
		this.getAndSaveOrderCancellableState(orderId);
		this.shopperService
			.getShopperPastOrder(orderId)
			.pipe(take(1))
			.subscribe((r) => {
				this.setOrderDetails(r.method || '', r.fulfilmentDate || '', r.fulfilmentTime || '');
				if (calledFrom) {
					this.router.navigateByUrl('/account/orders/(account-modal:cancel-order)' + '?source=' + calledFrom);
				} else {
					this.router.navigateByUrl('/account/orders/(account-modal:cancel-order)');
				}
			});
	}
}
